import { Trip } from "@/fetch/gworld";
import create from "zustand";
import { persist } from "zustand/middleware";

type CurrentGAppVersionState = {
  currentVersion: string | null | undefined;
  setCurrentVersion: (current: string | null | undefined) => void;
};

const useCurrentGAppVersionStore = create(
  persist<CurrentGAppVersionState>(
    (set) => ({
      currentVersion: null,
      setCurrentVersion: (currentVersion) => set({ currentVersion }),
    }),
    {
      name: "current-gapp-version",
    }
  )
);

const useCurrentGAppVersion = () => {
  const { currentVersion, setCurrentVersion } = useCurrentGAppVersionStore();

  return { setCurrentVersion, currentVersion };
};

export default useCurrentGAppVersion;
